import { LegalPage } from "@/components/LegalPage";

export default function Refund() {
  return (
    <LegalPage eyebrow="Legal" title="Refund & Cancellation Policy" updated="Effective 1 June 2026" testid="refund-page">
      <p>This Refund &amp; Cancellation Policy explains how payments, cancellations and refunds are handled for purchases made on KRV Prime, an independent financial-market education and information platform.</p>

      <h2>1. Scope</h2>
      <p>This policy applies to paid courses, programs, digital products, books and any other paid offerings purchased through KRV Prime. Free content, tools and research are not covered as no payment is involved.</p>

      <h2>2. Digital Nature of Products</h2>
      <p>Our courses and digital materials provide immediate access to educational content. Because these are digital products delivered instantly, they are generally <strong>non-refundable</strong> once access has been granted or content has been consumed, except as described below.</p>

      <h2>3. Cancellation Window</h2>
      <p>You may request a cancellation and full refund within <strong>7 days</strong> of purchase, provided that:</p>
      <ul>
        <li>You have not completed more than 20% of the course content, and</li>
        <li>You have not downloaded any downloadable materials, certificates or resources.</li>
      </ul>
      <p>Requests made after this window, or after substantial consumption of content, are not eligible for a refund.</p>

      <h2>4. How to Request a Refund</h2>
      <p>To request a cancellation or refund, email <strong>contact@krvprime.com</strong> from your registered email address with your order details and reason for the request. Our team will review and respond within 5–7 business days.</p>

      <h2>5. Refund Processing</h2>
      <p>Approved refunds are processed to the original payment method within 7–10 business days. The exact timeline may vary depending on your bank or payment provider. Any applicable payment gateway charges may be deducted where permitted.</p>

      <h2>6. Non-Refundable Situations</h2>
      <ul>
        <li>Requests made after the 7-day cancellation window.</li>
        <li>Courses that have been substantially completed.</li>
        <li>Books and physical/downloadable products that have been delivered or downloaded.</li>
        <li>Purchases made using promotional offers or discounts, unless stated otherwise.</li>
      </ul>

      <h2>7. Failed or Duplicate Payments</h2>
      <p>If you were charged more than once for the same order, or a payment was deducted without access being granted, contact us immediately at <strong>contact@krvprime.com</strong>. Verified duplicate or failed transactions will be refunded in full.</p>

      <h2>8. Changes to This Policy</h2>
      <p>We may update this policy from time to time. The version published on this page at the time of your purchase governs that transaction.</p>

      <h2>9. Contact</h2>
      <p>Questions about refunds or cancellations? Email <strong>contact@krvprime.com</strong>.</p>
    </LegalPage>
  );
}
